/**
 * 包含整个项目中所有的请求接口函数： 接口请求函数
 * 函数的返回值是promise对象
 */

import ajax from './ajax'
import { urlMaps } from '../config/urlMaps'

/**
 * 意见反馈
 * @returns promise
 */
export const feedbackApiPost = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.post({
    url: urlMaps.feedbackApi,
    data: params,
    ...rest,
  })
}

/**
 * 支付状态
 * @returns promise
 */
export const orderPayStatusGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.orderPayStatusApi,
    data: params,
    ...rest,
  })
}

/**
 * 获取微信支付参数
 * @returns promise
 */
export const payByOrderIdApiGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.payByOrderIdApi,
    data: params,
    ...rest,
  })
}
/**
 * 商品组件
 * @returns promise
 */
export const componentNextApiGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    showLoading: true,
    url: urlMaps.componentNextApi,
    data: params,
    ...rest,
  })
}

/**
 * 提交申请退货接口
 * @returns promise
 */
export const aftersalesConfirmPost = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.post({
    showLoading: true,
    url: urlMaps.aftersalesConfirmApi,
    data: params,
    ...rest,
  })
}
/**
 * 申请售后
 * @returns promise
 */
export const aftersalesApplyListGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    showLoading: true,
    url: urlMaps.aftersalesApplyListApi,
    data: params,
    ...rest,
  })
}
/**
 * 授信收支明细
 * @returns promise
 */
export const creditDetailGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    showLoading: true,
    url: urlMaps.creditDetailApi,
    data: params,
    ...rest,
  })
}
/**
 * 授信额度转换
 * @returns promise
 */
export const customerRechargeGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    showLoading: true,
    url: urlMaps.customerRechargeApi,
    data: params,
    ...rest,
  })
}
/**
 * 切换站点
 * @returns promise
 */
export const changeSiteGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.changeSiteApi,
    data: params,
    ...rest,
  })
}
/**
 * 授信余额
 * @returns promise
 */
export const creditGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    showLoading: true,
    url: urlMaps.creditApi,
    data: params,
    ...rest,
  })
}

/**
 * 更改手机号提交验证码
 * @returns promise
 */
export const telephoneChangeGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.telephoneChangeApi,
    data: params,
    ...rest,
  })
}
/**
 * 设置获取手机信息
 * @returns promise
 */
export const telephoneChangeAllowGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.telephoneChangeAllowCheckApi,
    data: params,
    ...rest,
  })
}
/**
 * 追踪物流
 * @returns promise
 */
export const trackingLogisticsGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.trackingLogisticsApi,
    data: params,
    ...rest,
  })
}

/**
 *  申请售后
 * @returns promise
 */
export const confirmReceiptGet = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    showLoading: true,
    url: urlMaps.confirmReceiptApi,
    data: params,
    ...rest,
  })
}

/**
 *  申请售后
 * @returns promise
 */
export const applyAfterSalesPost = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.post({
    isFormData: true,
    showLoading: true,
    url: urlMaps.applyAfterSalesApi,
    data: params,
    ...rest,
  })
}

/**
 *  取消订单
 * @returns promise
 */
export const cancelOrderPost = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.post({
    url: urlMaps.cancelOrderApi,
    data: params,
    ...rest,
  })
}

/**
 *  订单详情
 * @returns promise
 */
export const getOrderDetailPost = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.post({
    url: urlMaps.orderDetailApi,
    data: params,
    ...rest,
  })
}

/**
 *  商品详情切地址
 * @returns promise
 */
export const goodDetailChangeAddress = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.goodDetailChangeAddressApi,
    data: params,
    ...rest,
  })
}

/**
 *  密码提交
 * @returns promise
 */
export const validateCreditPwd = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.setUpCreditPwdApi,
    data: params,
    ...rest,
  })
}

/**
 * 短信校验
 * @returns promise
 */
export const validateCode = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.validateCodeApi,
    data: params,
    ...rest,
  })
}

/**
 * 短信验证码
 * @returns promise
 */
export const requestSendCode = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.sendCodeApi,
    data: params,
    ...rest,
  })
}

/**
 * 客户渠道支付确认
 * @returns promise
 */
export const customerPayConfirm = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.post({
    url: urlMaps.customerPayConfirmApi,
    data: params,
    ...rest,
  })
}

/**
 * 客户渠道支付
 * @returns promise
 */
export const getPayCustomer = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.payCustomerApi,
    data: params,
    ...rest,
  })
}

/**
 * 支付列表
 * @returns promise
 */
export const getOrderPayInfo = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.getOrderPayInformationApi,
    data: params,
    ...rest,
  })
}

/**
 * 推荐列表
 * @returns promise
 */
export const getRecommendGoods = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.recommendGoodsApi,
    data: params,
    ...rest,
  })
}

/**
 * 获取 token
 * @returns promise
 */
export const getUserInfo = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.userInfoApi,
    data: params,
    ...rest,
  })
}

/**
 * 获取 token
 * @returns promise
 */
export const getToken = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    showToast: false,
    url: urlMaps.userAuthApi,
    data: params,
    ...rest,
  })
}

/**
 * 获取 token
 * @returns promise
 */
export const getTelephoneCode = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    isFormData: true,
    url: urlMaps.telephoneCodeApi,
    data: params,
    ...rest,
  })
}

/**
 * 获取 token
 * @returns promise
 */
export const loginIn = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.telephoneBindApi,
    data: params,
    ...rest,
  })
}

/**
 * 根据key获取国内的地址， 在 application 中应用在添加地址中
 * @param {*} key
 */
export const reqAddress = key => {
  return ajax.post({
    url: `default/address/get`,
    data: {
      key: key ? key : '',
    },
  })
}

/**
 * 退出登录
 * @returns
 */
export const Logout = () => {
  return ajax.post({
    url: `default/user/logout`,
    data: {},
  })
}

/**
 * 获取主页分类列表 catelist
 * @returns
 */
export const reqCateList = () => {
  return ajax.post({
    url: `default/cat/list`,
    data: {},
  })
}

/**
 * 获取详细分类列表 子分类
 * @param {*} catId
 * @returns
 */
export const reqcateDetail = catId => {
  return ajax.post({
    url: `default/cat/detail`,
    data: { catId },
  })
}

export const reqcateTopClass = () => {
  return ajax.get({
    method: 'get',
    url: urlMaps.TopClass,
    data: {},
  })
}

/**
 * 主页数据接口
 * @param {*} platform
 * @returns
 */
export const main = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.get({
    url: urlMaps.menuConfigApi,
    data: params,
    ...rest,
  })
}

/**
 * 商品详情
 * @param {*}
 * @returns
 */
export const goodsDetail = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.post({
    isFormData: true,
    url: urlMaps.getGoodsApi,
    data: params,
    ...rest,
  })
}

/**
 * 搜索检索提示
 * @param {*} key
 * @returns
 */
export const getSearchKey = key => {
  return ajax.post({
    url: `default/goods/getSearchKey`,
    data: { key: key },
  })
}

/**
 * 根据 keyword 进行搜索
 * @param {*} keyWord
 * @param {*} pageNum
 * @param {*} pageSize
 * @returns
 */
export const doSearch = (keyWord, pageNum, pageSize) => {
  return ajax.post({
    url: `default/goods/doSearch`,
    data: { queryName: keyWord, pageNum, pageSize },
  })
}

/**
 * 搜索参数数据， 返回推荐数据
 * @param {*} count
 * @returns
 */
export const metisCart = count => {
  return ajax.post({
    url: `default/goods/metisCart`,
    data: { count },
  })
}

/**
 * 主页分类 根据queryId 进行搜索
 * @param {*} queryId
 * @param {*} queryString
 * @param {*} pageNum
 * @param {*} pageSize
 * @returns
 */
export const queryIdSearch = (queryId, queryString, pageNum, pageSize) => {
  return ajax.post({
    url: `default/goods/queryIdSearch`,
    data: {
      queryId,
      queryString,
      pageNum,
      pageSize,
    },
  })
}

/**
 *  商品详情删除商品
 * @returns
 */
export const delGoodsCart = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.post({
    url: urlMaps.delGoodsCartApi,
    data: params,
    ...rest,
  })
}

/**
 *  商品详情规格
 * @returns
 */
export const getSpecifications = (obj = {}) => {
  const { params = {}, ...rest } = obj
  return ajax.post({
    url: urlMaps.getSpecificationsApi,
    data: params,
    ...rest,
  })
}

/**
 * 购物车总条数
 * @returns
 */
export const getCartCount = () => {
  return ajax.get({
    url: urlMaps.goodsCartCountApi,
    data: {},
  })
}

/**
 * 购物车列表
 * @returns
 */
export const getCartList = () => {
  return ajax.post({
    url: `default/order/cart/list`,
    data: {},
  })
}

/**
 * 购物车单个商品数量增加或者减少接口
 * @param {*} id
 * @param {*} pid
 * @param {*} goods_num
 * @returns
 */
export const changeCartGoodEdit = (id, pid, goods_num) => {
  return ajax.post({
    url: `default/order/cart/cartEdit`,
    data: { id, pid, goods_num },
  })
}

/**
 * 购物车修改选中状态
 * @param {*} data
 * @returns
 */
export const changeCartGoodSel = data => {
  return ajax.post({
    url: `default/order/cart/sel`,
    data: { data: JSON.stringify(data) },
  })
}

/**
 * 购物车商品删
 * @param {*} id
 * @param {*} pid
 * @returns
 */
export const delCartGood = (id, pid) => {
  return ajax.post({
    url: `default/order/cart/del`,
    data: { id, pid },
  })
}

/**
 * 获取用户收货地址列表
 * @returns
 */
export const getAddressList = () => {
  return ajax.post({
    url: `default/order/address/getList`,
    data: {},
  })
}

/**
 * 修改默认地址选择
 * @param {*} id
 * @param {*} uid
 * @returns
 */
export const getSetDefault = (id, uid) => {
  return ajax.post({
    url: `default/order/address/setDefault`,
    data: { id, uid },
  })
}

/**
 *  获取要显示模拟框的数据
 * @param {*} id
 * @param {*} uid
 * @returns
 */
export const getView = (id, uid) => {
  return ajax.post({
    url: `default/order/address/getView`,
    data: { id, uid },
  })
}

/**
 * 修改当前地址的信息
 * @param {*} id
 * @param {*} uid
 * @param {*} consigne
 * @param {*} tel
 * @param {*} province
 * @param {*} city
 * @param {*} area
 * @param {*} street
 * @param {*} detailAddress
 * @param {*} zipcode
 * @param {*} isDefault
 * @returns
 */
export const getUpdateAddress = (id, uid, consigne, tel, province, city, area, street, detailAddress, zipcode, isDefault) => {
  return ajax.post({
    url: `default/order/address/update`,
    data: {
      id,
      uid,
      consigne,
      tel,
      province,
      city,
      area,
      street,
      detailAddress,
      zipcode,
      isDefault,
    },
  })
}

/**
 * 添加地址
 * @param {*} consigne
 * @param {*} tel
 * @param {*} province
 * @param {*} city
 * @param {*} area
 * @param {*} street
 * @param {*} detailAddress
 * @param {*} zipcode
 * @param {*} isDefault
 * @returns
 */
export const getAddAddress = (consigne, tel, province, city, area, street, detailAddress, zipcode, isDefault) => {
  return ajax.post({
    url: `default/order/address/add`,
    data: {
      consigne,
      tel,
      province,
      city,
      area,
      street,
      detailAddress,
      zipcode,
      isDefault,
    },
  })
}

/**
 * 删除地址
 * @param {*} id
 * @param {*} uid
 * @returns
 */
export const getDelAddress = (id, uid) => {
  return ajax.post({
    url: `default/order/address/del`,
    data: { id, uid },
  })
}
/**
 * checkout 商品确认页接口
 * @param {*} cart_type  购物车
 * @returns
 */
export const getCheckoutData = (cart_type = 0) => {
  return ajax.post({
    url: `default/order/cart/checkout`,
    data: { cart_type },
  })
}

/**
 * submit 商品提交
 * @param {*} data
 * @param {*} cart_type
 * @returns
 */
export const getSubmitOrder = (data, cart_type = 0) => {
  return ajax.post({
    url: `default/order/cart/submit`,
    data: {
      ...data,
      cart_type,
    },
  })
}

/**
 * 获取支付二维码信息
 * @param {*} order_id
 * @param {*} order_type
 * @param {*} order_price
 * @param {*} order_name
 * @param {*} sign
 * @param {*} redirect_url
 * @param {*} extension
 * @returns
 */
export const getPayCode = (order_id, order_type, order_price, order_name, sign, redirect_url, extension) => {
  return ajax.post({
    url: `api/order`,
    data: {
      order_id,
      order_type,
      order_price,
      order_name: order_name,
      sign,
      redirect_url,
      extension,
    },
    //
  })
}

/**
 * 个人中心订单数据接口
 * /default/order/orderinfo/list
 *
 * @apiParam {pageIndex}  当前页
 * @apiParam {pageSize} 一页需要显示的条数
 * @apiParam {listType} 订单类型 待收货：3， 待付款： 0，已收货：5， 退款订单： 6，全部订单：10，回收站：11
 */

export const getOrderInfo = (pageIndex, pageSize, listType) => {
  return ajax.post({
    url: `default/order/orderinfo/list`,
    data: {
      pageIndex,
      pageSize,
      listType,
    },
  })
}

/**
 * 获取订单条数
 *
 * /default/order/getListCount
 *
 * @apiParam {status}  订单状态码
 */
export const getListCount = status => {
  return ajax.post({
    url: `default/order/getListCount`,
    data: {
      status,
    },
  })
}

export const getClassGoodList = ({ rest = {}, data = {}, showLoading } = {}) => {
  return ajax.get({
    url: urlMaps.goodsFromClass,
    showLoading: showLoading,
    data: {
      ...data,
    },
    ...rest,
  })
}

export const getCartLists = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.goodsCartListApi,
    data: {
      ...data,
    },
    ...rest,
  })
}

export const axiosCartChoose = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.goodsChooseApi,
    data: {
      ...data,
    },
    ...rest,
  })
}

// 添加购物车
export const axiosAddCount = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.addGoodsCartApi,
    data: {
      ...data,
    },
    ...rest,
  })
}

export const axiosDelGood = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.delGoodsCartApi,
    data: {
      ...data,
    },
    ...rest,
  })
}

export const axiosGetAddrList = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.homeAreaListApi,
    data: {
      ...data,
    },
    ...rest,
  })
}

export const axiosGetCityList = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.getCityApi,
    data: {
      ...data,
    },
    ...rest,
  })
}

export const axiosAddAddr = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.saveAdressApi,
    data: {
      ...data,
    },
    ...rest,
  })
}

export const axiosDelAddr = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.homeAreaDelApi,
    data: {
      ...data,
    },
    ...rest,
  })
}

export const axiosConfirmOrder = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.confirmOrder,
    showLoading: true,
    data: {
      ...data,
    },
    isFormData: true,
  })
}

export const axiosChangeCartAddr = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.changeAddressApi,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosHoldOrder = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.holdOrder,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosGetSearch = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.getSearchApi,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosGetUserinfo = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.userInfoApi,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosGetOrderList = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.orderListApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosBuyAgin = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.buyAgainApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosUrgeOrder = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.orderUrgeApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosAftersales = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.afterSalesApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosDeleteInvalidGood = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.delGoodsCartApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosChangeVoucher = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.chooseGoodsVoucherApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosAfterSaleDetail = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.afterSalesOrderDetailApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosAfterSaleProgress = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.afterSaleProgressApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosCancleAfterSaleApply = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.aftersalesCancelApplyApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosGetShipperList = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.shipperComponeyApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosShipperSubmit = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.shipperSubmitApi,
    // isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosSationList = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.userSiteApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosChangeSite = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.changeSiteApi,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosGetConfig = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.getConfig,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

export const axiosGetGoods = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.getGoods,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}
export const axiosGetCompareAttr = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.getCompareAttr,
    isFormData: true,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

// 获取单订单商品评价列表 - /api/wap/buyer/orderGoodsCommentOneList
export const axiosGetOrderGoodsCommentOneList = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.getOrderGoodsCommentOneList,
    isFormData: false,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

// 商品评价单个修改 - /api/wap/buyer/orderGoodsCommentOneSubmit
export const axiosOrderGoodsCommentOneSubmit = ({ rest = {}, data = {} } = {}) => {
  return ajax.post({
    url: urlMaps.orderGoodsCommentOneSubmit,
    isFormData: false,
    showLoading: true,
    data: {
      ...data,
    },
  })
}
// 获取需要评价订单商品列表 详情
export const axiosOrderGoodsCommentGoodsList = ({ rest = {}, data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.orderGoodsCommentGoodsList,
    isFormData: false,
    showLoading: true,
    data: {
      ...data,
    },
  })
}

// 商品评价批量提交
export const axiosOrderGoodsCommentListSubmit = ({ rest = {}, data = [] } = {}) => {
  return ajax.post({
    url: urlMaps.orderGoodsCommentListSubmit,
    isFormData: false,
    showLoading: true,
    data: data,
  })
}

// 商品所有状态的评价数目
export const axiosOrderGoodsCommentGoodsSum = ({ rest = {}, data = [] } = {}) => {
  return ajax.get({
    url: urlMaps.orderGoodsCommentGoodsSum,
    isFormData: false,
    showLoading: false,
    data: {
      ...data,
    },
  })
}
// 商品所有的评价
export const axiosOrderGoodsCommentList = ({ rest = {}, data = [] } = {}) => {
  return ajax.get({
    url: urlMaps.orderGoodsCommentList,
    isFormData: false,
    showLoading: true,
    data: {
      ...data,
    },
  })
}
/**
 * 首页轮播图以及金刚位数据
 * @returns Promise<any>
 */
export const axiosIndexBannerAndVajra = () => {
  return ajax.get({
    url: urlMaps.indexBannerAndVajra,
    isFormData: false,
    showLoading: true,
  })
}
/**
 * 秒杀商品
 * @returns Promise<any>
 */
export const axiosIndexMsGoods = ({ data = {}, showLoading = false, showToast = false } = {}) => {
  return ajax.get({
    url: urlMaps.indexMSGoods,
    isFormData: false,
    showLoading,
    showToast,
    data,
  })
}

/**
 * 新品
 * @returns Promise<any>
 */
export const axiosIndexNewGoods = ({ data = {}, showLoading = false, showToast = false } = {}) => {
  return ajax.get({
    url: urlMaps.indexNewGoods,
    isFormData: false,
    showLoading,
    showToast,
    data,
  })
}

/**
 * 二级页面数据
 */
export const axiosGetSecondaryPageApi = ({ data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.secondaryPageApi,
    isFormData: false,
    showLoading: true,
    data,
  })
}

/**
 * 获取二级页面数据 存在多个获取数据接口
 */
export const axiosGetSecondaryPageApi2 = ({ data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.secondaryPageApi2,
    isFormData: false,
    showLoading: true,
    data,
  })
}

/**
 * 获取二级页面分类数据
 */
export const axiosGetSecondaryPageClassApi = ({ data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.secondaryPageClassApi,
    isFormData: false,
    showLoading: true,
    data,
  })
}

/**
 * 获取二级页面分类关联的商品数据
 */
export const axiosGetSecondaryPageClassDataApi = ({ data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.secondaryPageClassDataApi,
    isFormData: false,
    showLoading: true,
    data,
  })
}

/**
 * zui新的物流信息查询
 * @param {*} param0
 * @returns
 */
export const axiosGetExpressList = ({ data = {} } = {}) => {
  return ajax.get({
    url: urlMaps.trackingLogisticsPackageApi,
    isFormData: false,
    showLoading: true,
    showToast: false,
    data,
  })
}
